module.exports = __webpack_public_path__ + "block-1-0.75x-02620e81ab98a2fa23949287ac388e37.webp";